// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
.detail-content {
  height: 100%;
  background-color: #e1eefe;
  padding: 23px 33px;
}

ngx-dropzone.task-dropzone {
  width: 21px;
  height: 21px;
  border: 0;
  background: #e1eefe;
  position: initial;
}

ngx-dropzone-label {
  width: 20px;
  height: 20px;
  margin: 0 !important;
  display: block;
  padding: 0;
  z-index: auto !important;
  position: static;
}

i-feather.fms-add-icon {
  height: 20px !important;
  width: 20px !important;
  color: #1ba953;
  opacity: 1;
}

.media-header {
  display: flex;
  justify-content: space-between;
}

.media-container {
  width: 100% !important;
  overflow-y: auto;
  display: grid;
  max-height: 300px;
  padding: 0 !important;
  margin: 0 !important;
}

.media-image {
  width: 90px;
  height: 90px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  border-radius: 5px;
  box-shadow: 0px 1px 4px #c4c4c4;
  background-color: #000;
}

.media-file {
  border-radius: 5px;
  box-shadow: 0px 1px 4px #c4c4c4;
  width: 90px;
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.4588235294);
  color: #000;
  position: relative;
  font-weight: 100;
  font-size: 12px;
  gap: 2px;
}
.media-file p {
  margin: 0;
}
.media-file i-feather {
  height: 25px !important;
  width: 25px !important;
  margin-right: 0px;
}
.media-file ngx-dropzone-remove-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  visibility: hidden;
}
.media-file:hover ngx-dropzone-remove-badge {
  visibility: visible;
}

.media-file-link {
  text-decoration: none;
}

.no-image {
  cursor: default;
}

.task-media {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 10px;
}

.media-image {
  position: relative;
}
.media-image .media-overlay {
  display: none;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.768627451);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  color: #fff;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  flex-direction: column;
}
.media-image .media-overlay p {
  margin: 0px;
}
.media-image .media-overlay .media-image-date {
  font-size: 8px;
}
.media-image .media-overlay .media-image-title {
  font-size: 10px;
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.media-image ngx-dropzone-remove-badge {
  visibility: hidden;
}
.media-image:hover ngx-dropzone-remove-badge {
  visibility: visible;
}
.media-image:hover .media-overlay {
  display: flex;
}

.media-date-title {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}

.media-date {
  font-size: 12px;
  color: #8291ae;
}

.media-file-date {
  font-size: 8px;
}

.media-file-title {
  font-size: 10px;
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/app/tasks/task-view/task-detail/task-detail.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC9LA;EACE,YAAA;EACA,yBDQe;ECPf,kBAAA;AAYF;;AARE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBDDa;ECEb,iBAAA;AAWJ;;AAPA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;EACA,gBAAA;AAUF;;AAPA;EACE,uBAAA;EACA,sBAAA;EACA,cDVU;ECWV,UAAA;AAUF;;AAPA;EACE,aAAA;EACA,8BAAA;AAUF;;AAPA;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;AAUF;;AAPA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,kBAAA;EACA,+BAAA;EACA,sBAAA;AAUF;;AAPA;EACE,kBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mDAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AAUF;AATE;EACE,SAAA;AAWJ;AATE;EACE,uBAAA;EACA,sBAAA;EACA,iBAAA;AAWJ;AATE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AAWJ;AARI;EACE,mBAAA;AAUN;;AALA;EACE,qBAAA;AAQF;;AALA;EACE,eAAA;AAQF;;AALA;EACE,aAAA;EACA,qCAAA;EACA,aAAA;AAQF;;AALA;EACE,kBAAA;AAQF;AAPE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;EACA,2CAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AASJ;AARI;EACE,WAAA;AAUN;AARI;EACE,cAAA;AAUN;AAPI;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AASN;AANE;EACC,kBAAA;AAQH;AALI;EACE,mBAAA;AAON;AALI;EACE,aAAA;AAON;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;AAKF;;AAFA;EACE,eAAA;EACA,cAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAFA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKF","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"../../../../styles/variables\";\n\n.detail-content {\n  height: 100%;\n  background-color: $fms-blue-light;\n  padding: 23px 33px;\n}\n\nngx-dropzone {\n  &.task-dropzone {\n    width: 21px;\n    height: 21px;\n    border: 0;\n    background: $fms-blue-light;\n    position: initial;\n  }\n}\n\nngx-dropzone-label {\n  width: 20px;\n  height: 20px;\n  margin: 0 !important;\n  display: block;\n  padding: 0;\n  z-index: auto !important;\n  position: static;\n}\n\ni-feather.fms-add-icon {\n  height: 20px !important;\n  width: 20px !important;\n  color: $fms-green;\n  opacity: 1;\n}\n\n.media-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.media-container {\n  width: 100% !important;\n  overflow-y: auto;\n  display: grid;\n  max-height: 300px;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.media-image {\n  width: 90px;\n  height: 90px;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-size: auto 100%;\n  background-position: center;\n  border-radius: 5px;\n  box-shadow: 0px 1px 4px #c4c4c4;\n  background-color: #000;\n}\n\n.media-file {\n  border-radius: 5px;\n  box-shadow: 0px 1px 4px #c4c4c4;\n  width: 90px;\n  height: 90px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  background-color: #ffffff75;\n  color: #000;\n  position: relative;\n  font-weight: 100;\n  font-size: 12px;\n  gap: 2px;\n  p {\n    margin: 0;\n  }\n  i-feather {\n    height: 25px !important;\n    width: 25px !important;\n    margin-right: 0px;\n  }\n  ngx-dropzone-remove-badge {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    visibility: hidden;\n  }\n  &:hover {\n    ngx-dropzone-remove-badge {\n      visibility: visible;\n    }\n  }\n}\n\n.media-file-link{\n  text-decoration: none;\n}\n\n.no-image {\n  cursor: default;\n}\n\n.task-media {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  row-gap: 10px;\n}\n\n.media-image{\n  position: relative;\n  .media-overlay{\n    display: none;\n    width: 100%;\n    height: 100%;\n    border-radius: 5px;\n    background: #000000c4;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    color: #fff;\n    justify-content: center;\n    align-items: center;\n    font-size: 12px;\n    font-weight: bold;\n    flex-direction: column;\n    p{\n      margin: 0px;\n    }\n    .media-image-date {\n      font-size: 8px;\n    }\n    \n    .media-image-title {\n      font-size: 10px;\n      max-width: 80px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  ngx-dropzone-remove-badge {\n   visibility: hidden;\n  }\n  &:hover{\n    ngx-dropzone-remove-badge {\n      visibility: visible;\n    }\n    .media-overlay{\n      display: flex;\n    }\n  }\n}\n\n.media-date-title {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.media-date {\n  font-size: 12px;\n  color: #8291ae;\n}\n\n.media-file-date {\n  font-size: 8px;\n}\n\n.media-file-title {\n  font-size: 10px;\n  max-width: 80px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
